/**
 * andamento.js — media mobile e linea di base personale.
 *
 * Sta fuori dal componente perche' e' matematica, e la matematica si
 * prova: da qui la si puo' eseguire con node e verificare sui casi
 * limite - una notte sola, buchi in mezzo, il giorno esatto in cui
 * scatta una soglia. Dentro un .jsx che importa un CSS non si puo'.
 */

export const NOTTI_PER_MEDIA = 14;   // sotto: solo punti
export const NOTTI_PER_BANDA = 30;   // sotto: nessuna linea di base
export const FINESTRA_MEDIA = 7;     // giorni della media mobile
export const FINESTRA_BANDA = 60;    // giorni su cui si calcola la base
export const MIN_NELLA_FINESTRA = 4; // notti minime perche' la media abbia senso

const GIORNO_MS = 86400000;

/** Il giorno come numero intero, per confrontare date senza fusi orari. */
export function aGiorni(iso) {
    const t = Date.parse(`${String(iso).slice(0, 10)}T00:00:00Z`);
    return Number.isFinite(t) ? Math.floor(t / GIORNO_MS) : NaN;
}

/**
 * Da righe di polar_recuperi a punti ordinati dal piu' vecchio.
 * Un campo assente resta NaN e non diventa zero: Number(null) e'
 * zero, ed e' cosi' che nascono i valori inventati.
 */
export function serie(righe, campo) {
    return righe
        .map((r) => ({
            giorno: String(r.giorno).slice(0, 10),
            gg: aGiorni(r.giorno),
            valore: r[campo] === null || r[campo] === undefined || r[campo] === ''
                ? NaN : Number(r[campo]),
        }))
        .filter((p) => Number.isFinite(p.gg))
        .sort((a, b) => a.gg - b.gg);
}

/**
 * Media mobile calcolata sulle DATE, non sulle posizioni nell'elenco.
 *
 * Se manca una notte, mediare le sette righe precedenti guarderebbe
 * indietro otto giorni senza dirlo. La finestra e' di sette giorni di
 * calendario; con meno di quattro notti dentro non si calcola nulla,
 * perche' una media su due valori non e' una media.
 */
export function mediaMobile(punti) {
    return punti.map((p) => {
        let somma = 0, quanti = 0;
        for (const q of punti) {
            if (q.gg <= p.gg && q.gg > p.gg - FINESTRA_MEDIA && Number.isFinite(q.valore)) {
                somma += q.valore;
                quanti++;
            }
        }
        return { ...p, media: quanti >= MIN_NELLA_FINESTRA ? somma / quanti : null };
    });
}

/**
 * Linea di base personale: media e scarto tipico delle ultime
 * FINESTRA_BANDA notti di QUESTA persona.
 *
 * Non e' un intervallo di normalita' e non deve diventarlo: dice dove
 * stanno di solito i valori di chi si sta guardando, non dove
 * dovrebbero stare. Per la variabilita' cardiaca un riferimento di
 * popolazione non esiste.
 */
export function lineaDiBase(punti) {
    const validi = punti.filter((p) => Number.isFinite(p.valore));
    if (validi.length < NOTTI_PER_BANDA) return null;

    const ultimo = validi[validi.length - 1].gg;
    const dentro = validi
        .filter((p) => p.gg > ultimo - FINESTRA_BANDA)
        .map((p) => p.valore);
    if (dentro.length < NOTTI_PER_BANDA) return null;

    const media = dentro.reduce((t, v) => t + v, 0) / dentro.length;
    const varianza = dentro.reduce((t, v) => t + (v - media) ** 2, 0) / dentro.length;
    return { media, sd: Math.sqrt(varianza), notti: dentro.length };
}

/** Quante notti con un valore utile ci sono. */
export const nottiValide = (punti) => punti.filter((p) => Number.isFinite(p.valore)).length;
